import { render, staticRenderFns } from "./ProductionReportInformation.vue?vue&type=template&id=65f19c56&scoped=true"
import script from "./ProductionReportInformation.vue?vue&type=script&lang=js"
export * from "./ProductionReportInformation.vue?vue&type=script&lang=js"
import style0 from "./ProductionReportInformation.vue?vue&type=style&index=0&id=65f19c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f19c56",
  null
  
)

export default component.exports